export const ManageRouting = [
    {
      path: "/project/manage/list",
      name: "project-manage-list",
      meta: { title: "项目管理" },
      component: () => import("@/views/project/manage/list/index.vue"),
    },
    
  ];
  